import instance from "./axiosInstance";
import { GarmentMeasurementDataResponse, GarmentMeasurementResult, GarmentMeasurementBatchRequest } from "../types/free-trial/garment-measurement-service/types";

export const submitGarmentMeasurement = async (accessToken: string, data: GarmentMeasurementBatchRequest): Promise<GarmentMeasurementDataResponse> => {
  try {
    const filteredImages = data.garment_images.filter((img) => img !== "");
    if (filteredImages.length === 0) {
      throw new Error("No valid images provided");
    }

    const firstImage = filteredImages[0];
    const base64Data = firstImage.includes(":") ? firstImage.split(":")[1] : firstImage;

    const response = await instance.post<GarmentMeasurementDataResponse>(
      "/api/v1/services/garmentMeasurement",
      { Image: base64Data },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    if (!response.data.ok) {
      return {
        ok: false,
        message: response.data.message || "Processing failed",
        data: { result: null as any },
        status_code: response.data.status_code || 500,
      };
    }

    const apiData = response.data.data;
    const result: GarmentMeasurementResult = {
      Details: {},
      MetaData: apiData.MetaData,
    };

    if (apiData.Measurements) {
      Object.entries(apiData.Measurements).forEach(([key, value]) => {
        if (value && value.Size && value.Size > 0) {
          result[key] = +value.Size.toFixed(2);
          result.Details[key] = value;
        }
      });
    }

    return {
      ok: response.data.ok,
      message: response.data.message,
      data: {
        result: result,
        ...apiData,
      },
      status_code: response.data.status_code,
    };
  } catch (error: any) {
    console.error("Error submitting garment measurement:", error);
    return {
      ok: false,
      message: error instanceof Error ? error.message : "Failed to process images",
      data: { result: null as any },
      status_code: 500,
    };
  }
};

export const submitSingleGarmentMeasurement = async (accessToken: string, imageBase64: string): Promise<GarmentMeasurementDataResponse> => {
  try {
    const base64Data = imageBase64.includes(":") ? imageBase64.split(":")[1] : imageBase64;

    const response = await instance.post<GarmentMeasurementDataResponse>(
      "/api/v1/services/garmentMeasurement",
      { Image: base64Data },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    if (!response.data.ok) {
      return {
        ok: false,
        message: response.data.message || "Processing failed",
        data: { result: null as any },
        status_code: response.data.status_code || 500,
      };
    }

    const apiData = response.data.data;
    const result: GarmentMeasurementResult = {
      Details: {},
      MetaData: apiData.MetaData,
    };

    if (apiData.Measurements) {
      Object.entries(apiData.Measurements).forEach(([key, value]) => {
        if (value && value.Size && value.Size > 0) {
          result[key] = +value.Size.toFixed(2);
          result.Details[key] = value;
        }
      });
    }

    return {
      ok: response.data.ok,
      message: response.data.message,
      data: {
        result: result,
        ...apiData,
      },
      status_code: response.data.status_code,
    };
  } catch (error: any) {
    console.error("Error submitting single garment measurement:", error);
    return {
      ok: false,
      message: error instanceof Error ? error.message : "Failed to process image",
      data: { result: null as any },
      status_code: 500,
    };
  }
};
